import React from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../styles/WhyInvest.scss";

const cards = [
  {
    number: "01",
    title: "Location & Accessibility",
    text: "Prime location in Khandshi-Nesave,Kamshet valley,near Shirota Dam,Uksan Dam, & Indrayani River,peaceful green zone",
  },
  {
    number: "02",
    title: "Plot Size",
    text: "Large 10,000 sq.ft NA plots – rare in the market",
  },
  {
    number: "03",
    title: "Pricing Advantage",
    text: "Pre-launch price Rs.550/- per sq.ft ,55lacs for 10,000 sq.ft - significantly lower than market NA rates",
  },
  {
    number: "04",
    title: "Amenities",
    text: "Lonavalley offers Resort style Luxury",
  },
  {
    number: "05",
    title: "Usage Flexibility",
    text: "Resort sanctioned plots also usable for residential purposes (ideal for large Farmhouses with resort access)",
  },
  {
    number: "06",
    title: "Unmatched in the Lonavalley Region market",
    text: "Offers the largest plots,lowest per sq.ft price,premium resort style amenities,and Dual use Flexibility - Unmatched in the Lonavalley Region market",
  },
  {
    number: "07",
    title: "Peaceful Lifestyle",
    text: "Escape city crowds with nature-connected living.",
  },
  
];

export default function WhyInvest() {
  return (
    <section className="why-invest">
      <div className="container">
        <h2 className="section-title">Lonavalley: The 360° Smart Investment Choice
        </h2>

        <Swiper
          modules={[Pagination, Navigation]}
          spaceBetween={30}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 2 },
          }}
          className="why-swiper"
        >
          {cards.map((c, i) => (
            <SwiperSlide key={i}>
              <motion.div
                className={`why-item`}
                initial={{ y: 50, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: true }}
              >
                <div className="why-number">{c.number}</div>
                <div className="why-content">
                  <h3>{c.title}</h3>
                  <p>{c.text}</p>
                </div>
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
